/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {PropertyDetailView} from "../../property/views/PropertyDetailView";
const route = [{webpackEntry: "propertyDetail", path: rpAppPath.property.detail.base, component: PropertyDetailView}];

(function () {
    rpClient(route);
})();
